import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Product from './components/Product';
import Contact from './components/Contact';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProductDetail from './components/ProductDetail';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import CustomerInfoForm from './components/CustomerInfoForm';
import WishlistPage from "./components/WishlistPage";
import Signup from './components/buttons/Signup';
import Login from './components/buttons/Login';
import SignupModal from './components/buttons/SignupModal';
import Bulk from './components/Bulk';
import Return from './components/Return';
import PrivacyPolicy from './components/PrivacyPolicy';
import Payment from './components/Payment';
import Order from './components/Order';
import RatingsReview from './components/RatingsReview';
import { useState, useEffect } from 'react';
import { sendRequest } from './ApiRequest';
import { BASE_URL } from './URL/constants';
import SalonFinder from './components/SalonFinder';
import ProtectedRoute from './components/common/ProtectedRoute';

function App() {
  const [headerEnabled, setHeaderEnabled] = useState(true);
  const [footerEnabled, setFooterEnabled] = useState(true);

  useEffect(() => {
    const fetchEnabledFlags = async () => {
      try {
        const response = await sendRequest(
          'POST',
          `${BASE_URL}/v1/public_site/public_site_info/get_list`
        );
        
        const publicSiteInfo = response.data.data.public_site_info;
        if (publicSiteInfo) {
          setHeaderEnabled(publicSiteInfo.header_enabled !== false);
          setFooterEnabled(publicSiteInfo.footer_enabled !== false);
        }
      } catch (error) {
        console.error('Error fetching enabled flags:', error);
        // Default to showing header and footer if API fails
        setHeaderEnabled(true);
        setFooterEnabled(true);
      }
    };

    fetchEnabledFlags();
  }, []);

  return (
    <div className="App">
      {headerEnabled && <Header />}
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Product />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/customer-info" element={<CustomerInfoForm />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/signup" element={< Signup />} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/wishlist" element={<WishlistPage />} />
          <Route path="/bulk" element={<Bulk/>} />
          <Route path="/return" element={<Return/>} />
          <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/order" element={
            <ProtectedRoute>
              <Order />
            </ProtectedRoute>
          } />
          <Route path="/ratings-review" element={<RatingsReview />} />
          <Route path="/salon-finder" element={<SalonFinder />} />
        </Routes>
      </div>
      {footerEnabled && <Footer />}
    </div>
  );
}

export default App;